var RespondConfirmation = /** @class */ (function () {
    function RespondConfirmation() {
    }
    return RespondConfirmation;
}());
export { RespondConfirmation };
var CustomRespondConfirmation = /** @class */ (function () {
    function CustomRespondConfirmation() {
    }
    return CustomRespondConfirmation;
}());
export { CustomRespondConfirmation };
